import { render, staticRenderFns } from "./gameHub.vue?vue&type=template&id=75601bb8&scoped=true"
import script from "./gameHub.vue?vue&type=script&lang=js"
export * from "./gameHub.vue?vue&type=script&lang=js"
import style0 from "./gameHub.vue?vue&type=style&index=0&id=75601bb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75601bb8",
  null
  
)

export default component.exports